import {showEditAdditionalOptionsModal} from '../Modals/EditAdditionalOptionsModal.js'
import {SHIPPER_NAMES} from '../../../common/constants/ShipperNames.js'
import {useLabelConfigContext} from '../LabelConfigContext.js'
import className from '../../../common/className.js'

/**
 * Link to modal to edit additional label config options
 *
 * @param {Object} props
 * @param {String} props.shipperType
 * @param {Boolean} props.singleShipperType
 * @returns {React.ReactNode}
 */
export default function EditAdditionalOptions({
  shipperType,
  singleShipperType,
}) {
  const {labelInfoID, onChange, isLabelEnableMode} = useLabelConfigContext()

  return (
    <li
      className={className`list__item fs-n0 lh-md margin-top-5 margin-bottom-0 ${{
        'list__item--square': !singleShipperType,
      }}`}
    >
      {!singleShipperType && (
        <strong className="v-align-base margin-right-5">
          {SHIPPER_NAMES[shipperType]}
        </strong>
      )}
      <button
        className={className`btn ${{
          'btn--link inline-block fs-n0 lh-md v-align-base': !singleShipperType,
          'btn--primary btn--primary-ol btn--x-sm': singleShipperType,
        }}`}
        type="button"
        id="edit_additional_options"
        onClick={() =>
          showEditAdditionalOptionsModal({
            labelInfoID,
            shipperType,
            onChange,
            isLabelEnableMode,
          })
        }
      >
        View/Edit
      </button>
    </li>
  )
}
